<template>
  <div class="card-wrapper">
    <b-card v-for="product in products" :key="product.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1 pr-4">
          <p class="card-text w-100 mb-lg-0 mb-2 mr-2">
            {{ product.name }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoPage(product.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-2"></i>

          <i @click="handleDelete(product.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { adminRoot } from '@/constants/config'

export default {
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('products/deleteSingleProduct', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoPage(id) {
      this.$router.push(`${adminRoot}/products/edit/${id}`)
    }
  }
}
</script>
